var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 51V46.3333C39.2 43.858 38.2307 41.484 36.5054 39.7337C34.78 37.9833 32.44 37 30 37H16.2C13.76 37 11.42 37.9833 9.69462 39.7337C7.96928 41.484 7 43.858 7 46.3333V51",
    stroke: "#744DFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2031 9.29883C41.176 9.81769 42.9231 10.9864 44.1704 12.6216C45.4176 14.2568 46.0944 16.2659 46.0944 18.3335C46.0944 20.4011 45.4176 22.4101 44.1704 24.0453C42.9231 25.6805 41.176 26.8493 39.2031 27.3681",
    stroke: "#744DFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0016 50.9999V46.3332C53 44.2652 52.3216 42.2563 51.0727 40.6219C49.8238 38.9876 48.0753 37.8202 46.1016 37.3032",
    stroke: "#744DFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0984 27.6666C28.1795 27.6666 32.2984 23.488 32.2984 18.3333C32.2984 13.1787 28.1795 9 23.0984 9C18.0174 9 13.8984 13.1787 13.8984 18.3333C13.8984 23.488 18.0174 27.6666 23.0984 27.6666Z",
    stroke: "#744DFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterview);
export default __webpack_public_path__ + "static/media/interview.c7a41318d0070cdfed3627f8bfb4961b.svg";
export { ForwardRef as ReactComponent };